import React from 'react'
import styles from "./LoaderPage.module.css"
import { Box } from '@primer/react'
import { useWindowSize } from '../../hooks/useWindowSize';
export const LoaderPage = () => {
    const { height } = useWindowSize();
    return (
        <>
            <div style={{
                height: height - 100,
                display: "flex",
                alignItems: "center",
                width: "100%",
                background: "transparent",
                flexDirection: "column",
                justifyContent: "center"

            }}>
                <Box className={styles.logoContainer}>
                    <img alt='logo' className={styles.logo} style={{ height: "120px" }} src="../../images/logo.png" />
                    <div className={styles.lightOverlay}></div>
                </Box>

            </div>
        </>
    )
}

export default LoaderPage